/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ParameterConstraintAllowedValue {
    getFixupPrototypeFunction() { return ParameterConstraintAllowedValue.fixupPrototype; }

    static newInstance(model: Partial<ParameterConstraintAllowedValue>): ParameterConstraintAllowedValue {
        let obj = Object.assign(new ParameterConstraintAllowedValue(), model);
        ParameterConstraintAllowedValue.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ParameterConstraintAllowedValue>): ParameterConstraintAllowedValue {
        if (!model) return null;
        return ParameterConstraintAllowedValue.newInstance(<ParameterConstraintAllowedValue> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ParameterConstraintAllowedValue) {
        if (!obj) return;

        models.ParameterConstraintAllowedValue.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ParameterConstraintAllowedValue): boolean {
        Object.setPrototypeOf(obj, ParameterConstraintAllowedValue.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Name of the allowed value of the parameter's constraint field
     */
    display_name: string;

    /**
     * Value of the allowed value of the parameter's constraint field
     */
    value: string;

}
